export default function EventMarker() {
  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src="/icons/Map-Icon_Spark.svg"
      alt="Event location marker"
      width={31}
      height={31}
    />
  );
}
